import React from 'react';
import Feature from '../../components/feature/Feature';
import './features.css';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { featuresData } from '../../data/featuresData';

const Features = () => {
  const { header, features } = featuresData;
  return (
    <div className="features-section" id="features">
      <div className="features-container">
        <div className="features-hero">
          <div className="features-badge">
            <CheckCircleIcon className="badge-icon" />
            <span>{header.badge.text}</span>
          </div>
          <h2 className="features-title">{header.title}</h2>
          <p className="features-description">
            {header.description}
          </p>
        </div>
        
        <div className="features-grid">
          {features.map((item, index) => (
            <Feature 
              title={item.title} 
              text={item.text} 
              icon={item.icon}
              color={item.color}
              key={item.title + index} 
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Features;